import { ArrowLeftOutlined } from '@ant-design/icons'
import { Company } from '@components/company/Company'
import { Employee } from '@components/employee/Employee'
import { Form } from '@components/form/Form'
import { Job } from '@components/job/Job'
import { FormContextProvider } from '@contexts/FormContext'
import { LoadingFullScreen } from '@layouts/LoadingFullScreen'
import { CampaignData, isEmployee } from '@models/Campaign'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { useAuth } from '@utils/auth/Auth'
import { CAMPAIGN_EMPLOYEE_URL } from '@utils/urls'
import { Card, Flex, Space, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'

const { Text } = Typography

const CampaignPage = () => {
  const { currentUser } = useAuth()
  const { campaignEmployeeId } = useParams<{ campaignEmployeeId: string }>()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [campaignData, setCampaignData] = useState<CampaignData | undefined>(
    undefined
  )

  useEffect(() => {
    if (!campaignEmployeeId) return
    setIsLoading(true)
    SBAPI.Fetch<CampaignData>(
      `${CAMPAIGN_EMPLOYEE_URL}/${campaignEmployeeId}/data`
    )
      .then((data) => {
        setCampaignData(data.data)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [campaignEmployeeId])

  if (isLoading || campaignData === undefined || currentUser === undefined) {
    return <LoadingFullScreen />
  }

  return (
    <Flex gap={16} vertical className="container-row">
      <Link to={'/'}>
        <Space>
          <ArrowLeftOutlined />
          <Text>Retour vers l&apos;accueil</Text>
        </Space>
      </Link>
      {!isEmployee(currentUser, campaignData.campaignEmployee) && (
        <Card
          styles={{ body: { padding: 15 } }}
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 999,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Space className="space-between w-full">
            <Employee.Avatar model={campaignData.campaignEmployee.employee} />
            <Space>
              <Job.Tag model={campaignData.campaignEmployee.job as any} />
              <Company.Tag
                model={campaignData.campaignEmployee.company as any}
              />
            </Space>
          </Space>
        </Card>
      )}
      <FormContextProvider campaignData={campaignData}>
        <Form.Wrapper />
      </FormContextProvider>
    </Flex>
  )
}
export default CampaignPage
